import { API, generic } from "api"

export default class CountriesService {
  static index = async ({ pageState }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_ADMIN_USERS_INDUSTRIES_INDEX_STATUS",
      stateDataKey: ["industries"],
      stateErrorKey: ["industriesErrors"],
      apiEndpoint: API.adminUsers.industries.index,
      apiUrlReplacements: {},
      apiData: {},
      errorMessage: "Indusries data could not be fetched.",
    })
  }
}
